import { columnDef, WorkSheetBase } from "./workSheetBase";



export class BlankSheet extends WorkSheetBase {
    protected modelingData(sourceData: any): any[] {
        //加工変更の必要がないのでそのまま返す
        return sourceData;
    }

    /**
     *
     */
    get DefaultRowData(): {} {
        return {};
    }

    /**
     *  カラム定義を構築
     * @param sourceData --- サーバデータの生データ
     */
    defineColumns(sourceData: any): columnDef[] {
        let columns: columnDef[] = [];
        return columns;
    }
}
